import { Component, OnInit } from '@angular/core';

import { DeckService } from '~/services/deck.service';
import { DocumentFinderApiService } from '~/services/document-finder-api.service';
import { DocumentFinderService } from '~/services/document-finder.service';
import { downloadBlob } from '~/utils/download';

@Component({
    selector: 'df-deck-step',
    templateUrl: './df-deck-step.component.html',
    styleUrls: ['./df-deck-step.component.scss'],
    standalone: false
})
export class DfDeckStepComponent implements OnInit {
    public newItem = '';
    public error = '';

    constructor(
        public df: DocumentFinderService,
        private decks: DeckService,
        private api: DocumentFinderApiService
    ) {}

    public get deck() { return this.df.deck; }

    /** A published pack anchors deck generation to the current review workflow. */
    public get published() { return this.df.published; }

    public get extras(): string[] { return this.decks.extrasOf(this.deck.prompt); }
    ngOnInit(): void {
        if (this.published && !this.deck.prompt) {
            this.deck.prompt = this.deck.original = this.decks.buildPrompt(this.df.included(), this.published.id);
        }
    }

    public addItem(): void {
        const v = this.newItem.trim();
        if (!v) { return; }
        this.deck.prompt = this.decks.addItem(this.deck.prompt, v);
        this.newItem = '';
        this.df.toast('Added to the prompt — generate to apply');
    }

    public reset(): void {
        this.deck.prompt = this.deck.original;
    }

    public async generate(): Promise<void> {
        if (this.deck.busy) { return; }
        if (!this.published) {
            this.df.toast('Publish the document pack before generating a deck.');
            return;
        }
        this.ngOnInit();
        this.error = '';
        this.deck.busy = true;
        this.deck.result = null;
        try {
            const pptx = await this.api.buildDeck({
                packId: this.published.id,
                name: 'Production Execution - Process Orders Explore Design Session',
                prompt: this.deck.prompt
            });
            if (!pptx) { throw new Error('The backend deck service is not configured.'); }
            this.deck.result = { pptx };
            this.df.toast('Explore Design Session deck is ready');
        } catch (e) {
            console.error('Deck generation failed', e);
            this.error = e instanceof Error ? e.message : 'Could not build the deck. Please retry.';
            this.df.toast(this.error);
        } finally {
            this.deck.busy = false;
        }
    }

    public download(): void {
        if (this.deck.result) {
            downloadBlob(this.deck.result.pptx, 'Production_Execution_Explore_Workshop.pptx');
        }
    }

    public goPublish(): void {
        this.df.go(5);
    }

    /** Back to the PBL backlog step. */
    public goBack(): void {
        this.df.go(6);
    }
}
